import styled, { CSSProperties } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const UserAvatar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const UserInfo = styled.span`
   display: flex;
  flex-direction: column;
`;

export const UserName = styled.span`
  
`;

export const UserFilial = styled.span`
  
`;

export const SkeletonCss = {
  height : 47,
  display:'flex',
  flexDirection:'column'
} as CSSProperties